<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wzZo5K/tc-custom/9781497666221.jpg?1734049792103" alt="This image is the cover for the book One for the Gods, The Peter & Charlie Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One for the Gods, The Peter & Charlie Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>In the follow-up to the gay romance bestseller <i>The Lord Won’t Mind</i>, Peter and Charlie’s marriage is put to the test when a young Frenchman enters their lives</b><br/><br/>After a decade together in a steady, happy relationship, a trip to the sun-baked Mediterranean is exactly what Peter and Charlie need. Peter, now an art dealer, and Charlie, an artist, travel to the Riviera to attend to some business. However, once there, they meet a man who pushes their fidelity to the breaking point—and past it.<br/> <br/>In this, the second novel of the bestselling Peter &amp; Charlie Trilogy, Gordon Merrick picks up with the couple’s lives a few years after <i>The Lord Won’t Mind</i> and in smart and scintillating fashion explores the ways the years can twist and warp a relationship. When their trip continues on a yacht through the Greek islands, Peter creates what he hopes is a good plan to mend their cracked bond, but instead may have created something that will rip them apart forever.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gordon Merrick
      </h2>
      
      <p class="authorDescription body article">Gordon Merrick (1916&ndash;1988) was an actor, television writer, and journalist. Merrick was one of the first authors to write about gay themes for a mass audience. He wrote fourteen books, including the beloved Peter &amp; Charlie Trilogy.&#160;<I>The Lord Won&rsquo;t Mind</I>&#160;spent four months on the&#160;<I>New York Times</I>&#160;bestseller list in 1970. Merrick&rsquo;s posthumously published novel&#160;<I>The Good Life</I>, coauthored&#160;with his partner, Charles G. Hulse, was a bestseller as well. Merrick died in Sri Lanka.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?269b5ed8